/**
 * Collection sort dropdown: navigates to the same collection URL with an
 * updated ?sort_by= param, matching Shopify's native collection sorting.
 */
(function () {
  var select = document.querySelector('[data-sort-select]');
  if (!select) return;

  select.addEventListener('change', function () {
    var url = new URL(select.getAttribute('data-collection-url'), window.location.origin);
    url.searchParams.set('sort_by', select.value);
    window.location.href = url.toString();
  });
})();
